<template lang="pug">
div
  el-form-item(label="多选" )
    el-switch(v-model="multiple2")
  el-form-item(label="专业类型" )
    el-select( v-model="specType" )
      el-option(v-for="item in list" :key="item.value"
        :label="item.label" :value="item.value")
  el-form-item(label="关联更新" )
  field-setting(v-bind="$props", v-model="specNameKey", label="- 专业名称")
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { SPEC_TYPE } from "./index";
export default {
  mixins: [settingMixin],
  props: {},
  data() {
    return {
      list: [
        {
          label: SPEC_TYPE.USER.LABEL,
          value: SPEC_TYPE.USER.VALUE
        },
        {
          label: SPEC_TYPE.PRJ_ALL.LABEL,
          value: SPEC_TYPE.PRJ_ALL.VALUE
        }
      ]
    };
  },
  computed: {
    ...mapVFOptions("specType", "specNameKey", "multiple2")
  }
};
</script>
